/* eslint-disable no-unused-vars */
import React, { Component, useContext } from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import { get as getCookie } from 'es-cookie';

// import survey from '../../context/survey';
import constants from '../../app/constants';
import locations from '../../app/locations';

/**
 * input[type='hidden'] - 汎用 component
 * @param {string} name input.name
 * @param {string} value input.value
 * @return {*} React.node - input[type='hidden']
 * @constructor
 */
const TagHidden = ({ name, value }) => (
  <input type={'hidden'} name={name} value={value} />
);

/**
 * cookie value をセットする input[type='hidden'] tag
 * @param {string} name input.name
 * @param {string} cookieName cookie name - 取得後 value へ設定します
 * @return {*} React.node - input[type='hidden']
 * @constructor
 */
const TagCookie = ({ name, cookieName }) => {
  const value = getCookie(cookieName);
  // console.log('TagCookie', name, cookieName, value);
  return (
    name && (
      <TagHidden
        name={name}
        value={typeof value === 'string' && value.length > 0 ? value : ''}
      />
    )
  );
};

/**
 * config.cookie 設定を hidden タグへ設定します
 * @param {*} cookie config.cookie, cookieRp / cookieRz
 * @return {*} React.node
 * @constructor
 * @since 20191212 - メンテナンス性を上げるために分離しました
 */
const TagCookies = ({ cookie = {} }) =>
  cookie.available ? (
    <>
      {cookie.cookieRp && (
        <TagCookie
          name={cookie.cookieRp.name}
          cookieName={constants.COOKIE_NAME_RP}
        />
      )}
      {cookie.cookieRz && (
        <TagCookie
          name={cookie.cookieRz.name}
          cookieName={constants.COOKIE_NAME_RZ}
        />
      )}
    </>
  ) : null;

/**
 * embedded {@link Nps} checked name / value を配置します
 * @param {*} nps Redux.store.nps nps.payload を使用します
 * @param {boolean} embedded embedded flag
 * @return {null|*} React.node
 * @constructor
 * @since 20191211 - Nps(another component) name / value を設定するために親切しました
 */
const TagNps = ({ nps, embedded }) => {
  // console.log('TagNps', nps);
  if (!embedded || !nps.payload || !nps.payload.value) {
    return null;
  }

  // embedded type nps key / value を input[type="hidden"] へ checked 後に再配置します
  return <TagHidden name={nps.payload.name} value={nps.payload.value} />;
};

/**
 * widget - エンドユーザーの入力がない送信項目を input[type='hidden'] の name / value 設定します
 * - c: 楽天
 * - l: ja
 * - cId - optional
 * - url: origin + pathname - {@link locations}.path
 * - href: href- {@link locations}.href
 * - ua: userAgent - `navigator.userAgent`
 * - cookie - Rp : {@link constants.COOKIE_NAME_RP}
 * - cookie - Rz : {@link constants.COOKIE_NAME_RZ}
 * @param {*} state React.Context config.state
 * @param {*} nps Redux - nps {@link nps.initial}
 * @param {boolean} embedded React.Context.survey.state.config.embedded - 埋め込みフラッグ
 * @return {*} React.node - input[type='hidden']
 * @constructor
 */
const Hidden = ({ state, nps = {}, embedded }) => {
  // /**
  //  * state {object} - {@link config}.reduce 戻り値
  //  * dispatch {function} - {@link config}.Context state 変更関数 - type 指定を行います
  //  */
  // const { state } = useContext(survey.Context);

  const { config } = state;

  // const isCookieAvailable = config.cookie && config.cookie.available;

  return (
    <>
      <TagHidden name={'c'} value={'楽天'} />
      <TagHidden name={'l'} value={'ja'} />
      <TagHidden name={config.cId.name} value={config.cId.value} />
      <TagHidden name={config.url.name} value={locations.path()} />
      <TagHidden name={config.href.name} value={locations.href()} />
      <TagHidden name={config.ua.name} value={window.navigator.userAgent} />
      <TagCookies cookie={config.cookie} />
      <TagNps nps={nps} embedded={embedded} />
    </>
  );
};

export default Hidden;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/hidden/Hidden.js